import { FC } from 'react';
import NumberFormat from 'react-number-format';
import { numberFormat } from 'constants/formats';
import { useTranslate } from 'hooks/useTranslate';

import { useContributionModal } from '../context/ContributionModalContext';
import ContributionTable from './ContributionTable';

const ContributionModalDataView: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useContributionModal();
  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="pay-amount">
          {t('Contribution')}
        </label>
        <div className="form-control-wrap">
          <div className="form-text-hint">
            <span className="overline-title">EUR</span>
          </div>
          <NumberFormat
            id="outlined-normal"
            className="form-control form-control-outlined"
            placeholder={t('Amount')}
            value={data.totalAmount}
            onChange={actions.handleChangeTotalAmount}
            thousandSeparator={numberFormat.thousandSeparator}
            decimalSeparator={numberFormat.decimalSeparator}
            allowNegative={false}
            required
          />
        </div>
      </div>

      <ContributionTable />
    </>
  );
};

export default ContributionModalDataView;
